export default "__VITE_ASSET__hlkDggCc__"